<template>
  <div class="map-banner">
    <div class="background-map">
      <maplibre-map :center="mapCenter" :initial-zoom="mapZoom" :navigation-options="{showCompass: false, showZoom: false, visualizePitch: false}" />
    </div>
    <div class="foreground-content-wrapper">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
import MaplibreMap from '@/components/maplibre-map'

export default {
  components: { MaplibreMap },

  props: {
    mapCenter: {
      type: Object,
      required: true
    },
    mapZoom: {
      type: Number,
      required: false,
      default: 12
    }
  }
}
</script>

<style lang="scss" scoped>
.map-banner {
  min-height: 280px;

  .background-map {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -2;
  }
}
</style>
